
import { defineComponent } from "vue";
import { DocumentFilePathConstants } from "@/constants/DocumentFilePathConstants";

export default defineComponent({
  name: "ResultReferred",
  setup(){
    const documentPaths = DocumentFilePathConstants;

    return {
      documentPaths
    };
  }
});
